/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

        function stateConfig($stateProvider) {
                $stateProvider.state('admin/ejemplar/usuario', {
                    parent: 'admin',
                    url: '/admin/ejemplares/:creadorLogin',
                    redirectTo: 'admin/ejemplar/usuario/list',
                    data: {
                         pageTitle: 'admin.ejemplar.ejemplar',
                         authorities: ['ROLE_ADMIN', 'ROLE_INVESTIGADOR']
                     },
                     ncyBreadcrumb: {
                         skip: true
                     },
                    views: {
                        'content@': {
                            templateUrl: 'app/admin/ejemplar/ejemplar.usuario.list.html',
                            controller: 'EjemplarUsuarioAdminController',
                            controllerAs: 'ctrl'
                        }
                    }
                }).state('admin/ejemplar/usuario/list', {
                    parent: 'admin/ejemplar/usuario',
                    url: '/listar/:page',
                    params: {
                        page: {value: '1', dynamic: true}
                    },
                    ncyBreadcrumb: {
                        label: 'admin.ejemplar.list.title'
                    }
                });
            }

})();
